import { create } from 'zustand';
import type { TempFoyer, TempBlock, TempDomain, TempCategory, TempLine, TempObjective, TempScenario } from './temp-types';
import type { BudgetSnapshot, PatrimoineCategory, PatrimoineLine, PatrimoineSnapshot, KPIThresholds } from '@/engine/types';

interface DataState {
  foyer: TempFoyer | null;
  blocks: TempBlock[];
  domains: TempDomain[];
  categories: TempCategory[];
  lines: TempLine[];
  objectives: TempObjective[];
  scenarios: TempScenario[];
  tags: string[];
  budgetSnapshots: BudgetSnapshot[];
  patrimoineCategories: PatrimoineCategory[];
  patrimoineLines: PatrimoineLine[];
  patrimoineSnapshots: PatrimoineSnapshot[];
  kpiThresholds: KPIThresholds | null;

  setFoyer: (foyer: TempFoyer) => void;
  setBlocks: (blocks: TempBlock[]) => void;
  setDomains: (domains: TempDomain[]) => void;
  setCategories: (categories: TempCategory[]) => void;
  setLines: (lines: TempLine[]) => void;
  setBudgetSnapshots: (snapshots: BudgetSnapshot[]) => void;
  setPatrimoineCategories: (cats: PatrimoineCategory[]) => void;
  setPatrimoineLines: (lines: PatrimoineLine[]) => void;
  setPatrimoineSnapshots: (snapshots: PatrimoineSnapshot[]) => void;
  setScenarios: (scenarios: TempScenario[]) => void;
  setObjectives: (objectives: TempObjective[]) => void;
  setKpiThresholds: (thresholds: KPIThresholds) => void;
  clearAll: () => void;
}

export const useDataStore = create<DataState>((set) => ({
  foyer: null,
  blocks: [],
  domains: [],
  categories: [],
  lines: [],
  objectives: [],
  scenarios: [],
  tags: [],
  budgetSnapshots: [],
  patrimoineCategories: [],
  patrimoineLines: [],
  patrimoineSnapshots: [],
  kpiThresholds: null,

  setFoyer: (foyer) => set({ foyer }),
  setBlocks: (blocks) => set({ blocks }),
  setDomains: (domains) => set({ domains }),
  setCategories: (categories) => set({ categories }),
  setLines: (lines) => set({ lines }),
  setBudgetSnapshots: (budgetSnapshots) => set({ budgetSnapshots }),
  setPatrimoineCategories: (patrimoineCategories) => set({ patrimoineCategories }),
  setPatrimoineLines: (patrimoineLines) => set({ patrimoineLines }),
  setPatrimoineSnapshots: (patrimoineSnapshots) => set({ patrimoineSnapshots }),
  setScenarios: (scenarios) => set({ scenarios }),
  setObjectives: (objectives) => set({ objectives }),
  setKpiThresholds: (kpiThresholds) => set({ kpiThresholds }),
  clearAll: () => set({
    foyer: null, blocks: [], domains: [], categories: [],
    lines: [], objectives: [], scenarios: [], tags: [],
    budgetSnapshots: [],
    patrimoineCategories: [], patrimoineLines: [], patrimoineSnapshots: [],
    kpiThresholds: null,
  }),
}));
